import React from 'react';
import SacredFamily from './SacredFamily';
import Upadevathas from './Upadevathas';

const Deities = () => (
  <section id="deities" className="section bg-gradient-to-b from-blue-50 to-indigo-50">
    <div className="container mx-auto px-4">
      <div className="text-center mb-12">
        <h2 className="text-4xl font-bold text-saffron mb-4">Deities</h2>
        <p className="text-lg text-gray-700 max-w-3xl mx-auto">
          The Sacred Family of Deities at Sree Krishnaswamy Temple
        </p>
        <div className="decorative-border"></div>
      </div>

      <div className="max-w-6xl mx-auto">
        <SacredFamily />
        <Upadevathas />

        <div className="text-center mb-12">
          <img
            src="https://customer-assets.emergentagent.com/job_krishna-temple/artifacts/mveekpi4_main%20deity.png"
            alt="Main deity of the temple"
            className="mx-auto max-w-full h-auto rounded-lg shadow-temple lotus-border"
          />
        </div>

        <div className="text-center mb-12">
          <img
            src="https://customer-assets.emergentagent.com/job_ef1b1145-f8f0-4391-9cb1-5b2f821776b0/artifacts/qhfqxarh_DocScanner%20Mar%2015%2C%202026%2011-45%20AM-1%282040534981393654%29.jpg"
            alt="Deity with floral decorations"
            className="mx-auto max-w-full h-auto rounded-lg shadow-temple lotus-border"
          />
        </div>

        <div className="bg-gradient-to-r from-saffron to-gold text-black rounded-xl p-8 text-center shadow-temple">
          <h3 className="text-2xl font-bold mb-4 text-black">Temple Architecture</h3>
          <p className="text-lg mb-4 text-black">The Sacred Layout of the Temple Complex</p>
          <p className="text-base text-black">
            The temple follows traditional Kerala architecture with the main <em>Sree Kovil</em> (sanctum sanctorum) 
            at the center, surrounded by the <em>Nalambalam</em> and various Upadevatha shrines positioned according 
            to Vastu principles and spiritual significance.
          </p>
        </div>
      </div>
    </div>
  </section>
);

export default Deities;
